import { render, staticRenderFns } from "./app-banner.vue?vue&type=template&id=f1327f90&scoped=true"
import script from "./app-banner.vue?vue&type=script&lang=js"
export * from "./app-banner.vue?vue&type=script&lang=js"
import style0 from "./app-banner.vue?vue&type=style&index=0&id=f1327f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1327f90",
  null
  
)

export default component.exports